/**
 * @desc 仓库分页
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.warehouse.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/warehouse`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
